import React from "react";
import { Typography, Box, Button, Stack } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";


const EventLocation = ({ data }) => {


    const buttonNaviMap = {
        textTransform: "none",
        border: "none",
        backgroundColor: data?.buttonColour || data?.themeColour,
        borderRadius: "50px",
        fontSize: "12px",
        color: "white",
        px: "10px",
        py: "10px",
        "&:hover": {
            boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2)',
            transition: "0.4s",
        },
    };

    const wazeUrl = data.wazeMapLink;
    const googleMapUrl = data.googleMapLink;

    const location = data.location;
    const lat = location?.lat ?? null;
    const lng = location?.lng ?? null;
    const hasCoords = lat !== null && lng !== null;

    // Use lat/lng for precise pin if available, otherwise fall back to address search
    const mapEmbedUrl = hasCoords
        ? `https://www.google.com/maps?q=${lat},${lng}&z=16&output=embed`
        : `https://www.google.com/maps?q=${encodeURIComponent(data.eventAddress || '')}&z=16&output=embed`;



    return (
        <div
            style={{
                fontFamily: data.fontStyle || "Poppins, sans-serif",
                textAlign: "start",
                width: "100%",
                width: "300px",
                margin: "auto",
            }}
        >
            <Box
                sx={{
                    mt: 0,
                    px: 2,
                    pt: 3,
                    pb: 3,
                    border: "1px solid #ddd",
                    borderRadius: "20px",
                    backdropFilter: "blur(3px)",
                    background: "rgba(255, 255, 255, 0.85)",
                }}
            >

                {/* Embedded Google Map */}
                <Box
                    sx={{
                        width: "100%",
                        height: "200px",
                        borderRadius: "12px",
                        overflow: "hidden",
                    }}
                >
                    <iframe
                        title="Event Location Map"
                        src={mapEmbedUrl}
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </Box>

                {/* Buttons for navigation */}
                <Stack direction="row" spacing={1} mt={3}>
                    <Button variant="outlined" startIcon={<GoogleIcon />} sx={{ ...buttonNaviMap, flex: 1 }} onClick={() => window.open(googleMapUrl, "_blank")}>Google Maps</Button>
                    <Button
                        variant="outlined"
                        startIcon={<DirectionsCarIcon />}
                        sx={{ ...buttonNaviMap, flex: 1 }}
                        onClick={() => window.open(wazeUrl, "_blank")}
                    >
                        Waze
                    </Button>
                </Stack>
            </Box>
        </div>
    );
};

export default EventLocation;
